export const SEND_EMAIL_TO_RECOVER = 'SEND_EMAIL_TO_RECOVER';